import { Chart, ChartItem } from '@common/components/charts';
import { useFormatedVolume } from '@common/hooks';
import { useChartInteractions } from '@common/hooks/useChartInteractions';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { withVisualScaling } from './metricsHelpers';

interface CommercialOfferDistributionProps {
    data: ChartItem[];
}

export const CommercialOfferDistribution = ({
    data,
}: CommercialOfferDistributionProps) => {
    const { t } = useTranslation('dashboard');
    const { formatVolume } = useFormatedVolume();

    const displayData = useMemo(() => withVisualScaling(data, 'value'), [data]);

    const props = useChartInteractions(data);

    const valueFormatter = useCallback(
        (value: string | number) => {
            const num = Number(value);
            return isNaN(num) ? value : formatVolume(num);
        },
        [formatVolume],
    );

    return (
        <Chart.Box
            title={t(`programsCommercialOffers.title`)}
            legend={
                <Chart.Legend
                    items={data}
                    valueKey={'value'}
                    valueFormatter={valueFormatter}
                    {...props}
                />
            }
            maxHeight={'300px'}
            maxWidth={'250px'}
            mx={'4'}
        >
            <Chart.Bar
                data={displayData}
                // dataKey={'value'}
                dataKey={'visualHeight'}
                barSize={32}
                minPointSize={10}
                valueFormatter={valueFormatter}
                {...props}
            />
        </Chart.Box>
    );
};
